import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    textContainer: {
        flexDirection: "column",
        flex: 1
    },
    unselectableText: {
        ...webStyle({
            userSelect: "none"
        })
    },
    userInfoContainer: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    pwaContainer: {
        alignItems: "center"
    }
});
export default stylesheet;
